<template>
  <section class="section" id="lockers">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h1 class="title has-text-centered">
      {{ `${lockers.length} ${$tc("dashboard.lockers", lockers.length)}` }}
    </h1>

    <div class="columns is-multiline">
      <div
        v-for="locker in lockers"
        :key="locker._id"
        class="column is-one-third-desktop is-half-tablet"
      >
        <locker-card
          :locker="locker"
          @open-delivery-modal="openDeliveryModal"
        />
      </div>
    </div>

    <b-modal :active.sync="isDeliveryModalOpen" has-modal-card>
      <delivery-modal :locker="locker" @get-lockers="getLockers" />
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import lockerCard from "./LockerCard";
import deliveryModal from "./locker-card/DeliveryModal";

export default {
  mixins: [common],

  components: {
    lockerCard,
    deliveryModal
  },

  data() {
    return {
      isLoading: false,
      isDeliveryModalOpen: false,
      locker: null
    };
  },

  computed: {
    ...mapGetters(["lockers"])
  },

  methods: {
    getLockers() {
      this.isLoading = true;
      this.$store
        .dispatch("getLockers")
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    openDeliveryModal(locker) {
      this.locker = locker;
      this.isDeliveryModalOpen = true;
    }
  },

  mounted() {
    this.$store.dispatch("setLockerBeingManaged", null).catch(() => {
      this.alertError({ message: "UNEXPECTED_ERROR" });
    });
    this.getLockers();
  }
};
</script>

<style scoped>
#lockers {
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
